import {AnyAction} from 'redux';
import {Coordinate, FeatureFilter} from '../types';
import {ConfigActionType} from '../actionTypes';

/**
 * Akce konfigurace mapy.
 */
const ConfigActions = {
    /**
     * Nastaví téma konfigurace.
     *
     * @param area - Oblast store.
     * @param topic - Téma konfigurace.
     * @returns Akce.
     */
    setTopic: (area: string, topic: string): AnyAction => ({
        type: ConfigActionType.SET_TOPIC,
        area,
        topic,
    }),

    /**
     * Nastaví podkladovou vrstvu.
     *
     * @param area - Oblast store.
     * @param layerId - ID vrstvy nebo `null` pro její vypnutí.
     * @returns Akce.
     */
    setBackgroundLayer: (area: string, layerId: string | null): AnyAction => ({
        type: ConfigActionType.SET_BACKGROUND_LAYER,
        area,
        layerId,
    }),

    /**
     * Nastaví popisnou vrstvu.
     *
     * @param area - Oblast store.
     * @param layerId - ID vrstvy nebo `null` pro její vypnutí.
     * @returns Akce.
     */
    setForegroundLayer: (area: string, layerId: string | null): AnyAction => ({
        type: ConfigActionType.SET_FOREGROUND_LAYER,
        area,
        layerId,
    }),

    /**
     * Nastaví viditelné datové vrstvy.
     *
     * @param area - Oblast store.
     * @param layerIds - Pole ID vrstev.
     * @returns Akce.
     */
    setLayers: (area: string, layerIds: string[]): AnyAction => ({
        type: ConfigActionType.SET_LAYERS,
        area,
        layerIds,
    }),

    /**
     * Nastaví rozbalené uzly katalogu.
     *
     * @param area - Oblast store.
     * @param nodeIds - Pole ID uzlů katalogu.
     * @returns Akce.
     */
    setCatalogNodes: (area: string, nodeIds: string[]): AnyAction => ({
        type: ConfigActionType.SET_CATALOG_NODES,
        area,
        nodeIds,
    }),

    /**
     * Nastaví pozici středu mapy.
     *
     * @param area - Oblast store.
     * @param location - Souřadnice středu mapy.
     * @returns Akce.
     */
    setLocation: (area: string, location: Coordinate): AnyAction => ({
        type: ConfigActionType.SET_LOCATION,
        area,
        location,
    }),

    /**
     * Nastaví přiblížení mapy.
     *
     * @param area - Oblast store.
     * @param zoom - Hodnota přiblížení.
     * @returns Akce.
     */
    setZoom: (area: string, zoom: number): AnyAction => ({
        type: ConfigActionType.SET_ZOOM,
        area,
        zoom,
    }),

    /**
     * Nastaví filtr obsahu datových vrstev.
     *
     * @param area - Oblast store.
     * @param filter - Parametry filtru.
     * @returns Akce.
     */
    setFilter: (area: string, filter: FeatureFilter): AnyAction => ({
        type: ConfigActionType.SET_FILTER,
        area,
        filter,
    }),
};

export default ConfigActions as Readonly<typeof ConfigActions>;
